module.exports = "\r\n<footer class=\"main-footer\">\r\n  <div class=\"pull-right hidden-xs\">\r\n    <b>Versión</b> {{note_version}}\r\n  </div>\r\n  <strong>Todos los derechos reservados 2024,  <a href=\"prosof.com.co\">Prosof SAS ®</a>.</strong>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/footer/footer.component.html
// module id = ../../../../../src/app/main/footer/footer.component.html
// module chunks = main